import Vue from 'vue'
import VueRouter from 'vue-router'
import Error404 from '../views/Error404.vue'
import Landing from '../views/Landing.vue'
import Faq from '../views/Faq.vue'
import Contact from '../views/Contact.vue'
import Packets from '../views/Packets.vue'
import MoreThanLease from '../views/MoreThanLease.vue'
import Gallery from '../views/Gallery.vue'
import Step1 from '../views/Step1.vue'
import Step2 from '../views/Step2.vue'
import Step3 from '../views/Step3.vue'
import Step5 from '../views/Step5.vue'

Vue.use(VueRouter)

const routes = [
  { path: '*', 
    redirect: '/404' 
  },  
  {
    path: '/404',
    name: 'Error404',
    component: Error404
  },
  {
    path: '/',
    name: 'Landing',
    component: Landing
  },
  {
    path: '/pakiety',
    name: 'Packets',
    component: Packets
  },
  {
    path: '/faq',
    name: 'Faq',
    component: Faq
  },
  {
    path: '/kontakt',
    name: 'Contact',
    component: Contact
  },
  {
    path: '/wiecej-niz-najem',
    name: 'MoreThanLease',
    component: MoreThanLease
  },
  {
    path: '/galeria',
    name: 'Gallery',
    component: Gallery
  },
  {
    path: '/zamowienie/krok/1',
    name: 'Step1',
    component: Step1
  },
  {
    path: '/zamowienie/krok/2',
    name: 'Step2',
    component: Step2,
    beforeEnter: (to, from ,next) => {
      if(localStorage.formStep >= 1) {
        next();
      } else {
        next('/zamowienie/krok/1');
      };
    }
  },
  {
    path: '/zamowienie/krok/3',
    name: 'Step3',
    component: Step3,
    beforeEnter: (to, from ,next) => {
      if(localStorage.formStep > 2) {
        next();
      } else {
        next('/zamowienie/krok/2');
      };
    }
  },
  {
    path: '/zamowienie/krok/5',
    name: 'Step5',
    component: Step5
  },
]

const router = new VueRouter({
  mode: process.env.VUE_APP_ROUTER_MODE,
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

export default router
